/* eslint-disable prefer-template */
/* eslint-disable no-plusplus */

import { URLMAPPER } from "./Mapper";

export const generateData = (count, arr) => {
    const obj = {};
    const temp = {
        "double": 0,
        "queen": 0,
        "king": 0,
    }
    for (let i = 1; i <= count; i++) {
        obj["bedRoom" + i] = temp
    }
    const tempObj = JSON.parse(JSON.stringify(obj))
    if (arr.length > 0) {
        arr.forEach((item) => {
            const key = "bedRoom" + item.bedRoom
            if (key && tempObj[key] && item.bedType && item.bedType !== "sofa") {
                tempObj[key][item.bedType] = item.bedCount;
            }
        })
    }
    return tempObj
}



export const getApi = (mode)=> {
    const defaultURL = {
        app_url: process.env.REACT_APP_APP_URL,
        base_url: process.env.REACT_APP_BASE_URL,
        img_url: process.env.REACT_APP_IMAGE_URL,
      };
    return URLMAPPER?.[mode] || defaultURL;
}
// export const getApi = (mode) => {
//   const defaultURL = {
//     app_url: process.env.REACT_APP_APP_URL,
//     base_url: process.env.VITE_API_URL,
//     img_url: process.env.REACT_APP_IMAGE_URL,
//   };
//   const MAPPER = window?._env_ || null;
//   const URLMAPPER = MAPPER?.domains || null;
//   return URLMAPPER?.[mode] || defaultURL;
// };